import React, { useState } from "react";

const content = [
  {
    title: "🎥 Night of the Living Dead (1968)",
    url: "https://archive.org/embed/night_of_the_living_dead",
    type: "movie",
    thumbnail: "https://m.media-amazon.com/images/I/71rLby3rVqL._AC_SY679_.jpg"
  },
  {
    title: "📰 DW News Live",
    url: "https://www.youtube.com/embed/GEJdYj3p9c4",
    type: "news",
    thumbnail: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Deutsche_Welle_logo_2021.svg/320px-Deutsche_Welle_logo_2021.svg.png"
  },
  {
    title: "📻 The History of Rome Podcast",
    url: "https://open.spotify.com/embed/show/6znQZyygL8HEdQYg7gG1ug",
    type: "podcast",
    thumbnail: "https://upload.wikimedia.org/wikipedia/en/thumb/e/ea/History_of_Rome_Podcast_logo.png/220px-History_of_Rome_Podcast_logo.png"
  }
];

export default function StreamingHub() {
  const [selected, setSelected] = useState(null);

  return (
    <div className="p-6 bg-gray-900 min-h-screen text-white">
      <h1 className="text-3xl font-bold mb-6 text-center">🎬 My Streaming Hub</h1>

      {/* Grid of content cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {content.map((c, i) => (
          <div
            key={i}
            className="bg-gray-800 rounded-2xl overflow-hidden shadow-lg cursor-pointer hover:scale-105 transition-transform"
            onClick={() => setSelected(c)}
          >
            <img src={c.thumbnail} alt={c.title} className="w-full h-40 object-cover" />
            <div className="p-3">
              <h2 className="text-lg font-semibold">{c.title}</h2>
              <p className="text-sm opacity-75">{c.type}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Player section */}
      {selected && (
        <div className="mt-10">
          <h2 className="text-xl mb-4">{selected.title}</h2>
          <div className="aspect-video">
            <iframe
              src={selected.url}
              title={selected.title}
              className="w-full h-full rounded-lg"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}
